/* src/modules/students/cards/TutorListCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';
import { Paper, Grid, Chip, TextField } from '@material-ui/core';
import { filter, toUpper, isEmpty } from 'lodash';

import styles from './styles';

import { HeaderTable } from '../../../../app/components';
import CustomSelect from '../../../../app/components/Select';

import { fetchTutors, fetchTutor, clearSelectedTutor } from '../../actions';
import {
  getTutors,
  fetchTutorsState,
} from '../../selectors';
import { loadTexts } from '../../../../config/texts';

const TEXT_KEY = 'tutors';

class TutorListCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBy: '',
      searchByValue: '',
      filterByArray: [],
      filteredData: props.tutors,
      texts: loadTexts(TEXT_KEY, props.locale)
    };
    this.changeFilterStatus = this.changeFilterStatus.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this._onFetchTutors = this._onFetchTutors.bind(this);
    // this._onNextPage = this._onNextPage.bind(this);
    // this._onPrevPage = this._onPrevPage.bind(this);
    this._onSelectTutor = this._onSelectTutor.bind(this);
  }

  componentDidMount() {
    // const { listRange: { start, end }, tutors } = this.props;
    this._onFetchTutors();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.selectedUniversity !== this.props.selectedUniversity
      || nextProps.selectedOrganization !== this.props.selectedOrganization
    ) {
      this.props.fetchTutors({ tutorSearchInput: {
        _universities: [nextProps.selectedUniversity],
        _organizations: [nextProps.selectedOrganization],
        approved: true,
      } }).then(() => {
        this._filter();
        this.props.clearSelectedTutor();
      });
    }
  }

  _onFetchTutors() {
    const { selectedUniversity, selectedOrganization } = this.props;
    this.props.fetchTutors({ tutorSearchInput: {
      _universities: [selectedUniversity],
      _organizations: [selectedOrganization],
      approved: true,
    } }).then(() => {
      this._filter();
    });
  }

  _filter() {
    const { filterByArray, texts: { fields } } = this.state;
    if (isEmpty(filterByArray)) {
      this.setState({ filteredData: this.props.tutors });
    } else {
      filterByArray.forEach(f => {
        switch (f.searchBy) {
          case fields.name:
            this.setState({
              filteredData: filter(
                this.props.tutors,
                t => toUpper(t.name).includes(toUpper(f.value))
              ),
            });
            break;
          default:
            return null;
        }
      });
    }
  }

  changeFilterStatus(status) {
    this.setState({ searchBy: status });
  }

  handleDelete(chip) {
    const { filterByArray } = this.state;
    const chipData = [...filterByArray];
    const chipToDelete = chipData.indexOf(chip);

    chipData.splice(chipToDelete, 1);
    this.setState({ filterByArray: chipData }, () => {
      this._filter();
    });
  }

  keyBoardPressed(ev) {
    const { searchBy, searchByValue, filterByArray } = this.state;
    if (ev.key === 'Enter' && searchByValue !== '' && searchBy !== '') {
      const temp = filterByArray;
      temp.push({ searchBy, value: ev.target.value });
      this.setState({ searchByValue: '', filterByArray: temp }, () => this._filter());
    }
  }

  // _onNextPage() {
  //   // const { listRange: { end } } = this.props;
  //   this._onFetchTutors(end, end + 10);
  // }
  //
  // _onPrevPage() {
  //   // const { listRange: { start } } = this.props;
  //   this._onFetchTutors(start - 10, start);
  // }

  _onSelectTutor({ _id }) {
    this.props.fetchTutor({ tutor: _id });
  }

  renderChips() {
    const { classes } = this.props;
    const { filterByArray } = this.state;
    return filterByArray.map((c, index) => (
      <Chip
        key={index}
        label={`${c.searchBy}: ${c.value}`}
        onDelete={() => this.handleDelete(c)}
        className={classes.chip}
      />
    ));
  }

  renderFilter() {
    const { classes } = this.props;
    const { searchBy, searchByValue, texts } = this.state;

    return (
      <Grid container justify="flex-start" alignItems="flex-end" className={classes.gridContainer}>
        <TextField
          id="search"
          label={`${searchBy} ${texts.fields.filter}`}
          value={searchByValue}
          type="search"
          className={classes.textField}
          margin="normal"
          onChange={event => { this.setState({ searchByValue: event.target.value }); }}
          onKeyPress={ev => this.keyBoardPressed(ev)}
        />
        <CustomSelect dataArray={[texts.fields.name]} onValueChange={this.changeFilterStatus} withDefault />
        {this.renderChips()}
      </Grid>
    );
  }

  renderSearch() {
    const { texts: { fields } } = this.state;
    const totalArray = [fields.total, fields.current];
    const dateArray = [fields.all, fields.day, fields.week, fields.semester, fields.filter];
    return (
      <Grid container direction="row">
        <CustomSelect dataArray={totalArray} withDefault />
        <CustomSelect dataArray={dateArray} withDefault />
      </Grid>
    );
  }

  render() {
    const {
      classes,
      // listRange: { start, end, count },
      fetchState: { loading },
    } = this.props;
    return (
      <Paper className={classes.card}>
        {this.renderFilter()}
        {/* this.renderSearch() */}
        <HeaderTable
          label="tutors"
          data={this.state.filteredData}
          // paging
          // start={start}
          // end={end}
          // count={count}
          // onNext={this._onNextPage}
          // onPrev={this._onPrevPage}
          loading={loading}
          hover
          onRowClick={this._onSelectTutor}
        />
        {/* <CustomTable headers={HEADERS} data={DATA} isNumeric={ISNUMERIC} /> */}
      </Paper>
    );
  }
}

TutorListCard.propTypes = {
  classes: PropTypes.object.isRequired,
  fetchTutors: PropTypes.func.isRequired,
  fetchTutor: PropTypes.func.isRequired,
  fetchState: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
  }).isRequired,
  // listRange: PropTypes.shape({
  //   start: PropTypes.number.isRequired,
  //   end: PropTypes.number.isRequired,
  //   count: PropTypes.string.isRequired,
  // }).isRequired,
  tutors: PropTypes.array.isRequired,
  selectedUniversity: PropTypes.string.isRequired,
  selectedOrganization: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  selectedUniversity: state.auth.selectedUniversity,
  selectedOrganization: state.auth.selectedOrganization,
  tutors: getTutors(state),
  fetchState: fetchTutorsState(state),
  listRange: { start: 0, end: 10, count: 100 }, // getTutorsListRange(state),
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchTutors: params => dispatch(fetchTutors(params)()),
  fetchTutor: params => dispatch(fetchTutor(params)()),
  clearSelectedTutor: () => dispatch(clearSelectedTutor()),
});

export default compose(
  withStyles(styles, { name: 'TutorListCard' }),
  connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })
)(TutorListCard);



// WEBPACK FOOTER //
// ./src/modules/tutors/cards/TutorListCard/index.js